import React from 'react';
import { Icon } from '@material-ui/core';
import { ReviewStatus } from '../models/IReviewer';


interface IReviewerStatusProps {
    status: ReviewStatus
}

export default function ReviewerStatus(props: IReviewerStatusProps) {
    switch (props.status) {
        case ReviewStatus.complete:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Icon>
                        check_circle
                </Icon>
                &nbsp; Complete
                </div>
            )
        case ReviewStatus.inProgress:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Icon>
                        refresh
                    </Icon>
                     &nbsp; In Progress
                </div>
            )
        case ReviewStatus.discard:
            return (
                <div style={{ display: 'inline-flex' }}>
                    <Icon>
                        not_interested
                        </Icon>
                         &nbsp; Discarded
                </div>
            )
        default:
            return(props.status)
    }

}